// extracted by mini-css-extract-plugin
export default {"SampleFormModal":"SampleFormModal_SampleFormModal__6Q0TJ"};